<div class="toaster" [ngStyle]="{'border-left': '6px solid ' + color}">
  <div class="toaster-icon" [ngClass]="status">
    <ng-container *ngIf="status === 'success'">
      <svg width="28" height="28" fill="none" viewBox="0 0 28 28"><circle cx="14" cy="14" r="14" fill="#E6F7EC"/><path d="M9.5 14.5l3 3 6-6" stroke="#2E7D32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </ng-container>
    <ng-container *ngIf="status === 'error'">
      <svg width="28" height="28" fill="none" viewBox="0 0 28 28"><circle cx="14" cy="14" r="14" fill="#FDECEC"/><path d="M18 10L10 18M10 10l8 8" stroke="#D32F2F" stroke-width="2" stroke-linecap="round"/></svg>
    </ng-container>
  </div>
  <div class="toaster-content">
    <div class="toaster-title">{{ mainTitle }}</div>
    <div class="toaster-subtitle">{{ subTitle }}
      <ng-container *ngIf="view">
        <a class="toaster-view" (click)="onView()">View</a>
      </ng-container>
    </div>
  </div>
  <button class="toaster-close" (click)="onClose()" aria-label="Close">
    <svg width="20" height="20" fill="none" viewBox="0 0 20 20"><path d="M15 5L5 15M5 5l10 10" stroke="#232323" stroke-width="2" stroke-linecap="round"/></svg>
  </button>
</div> 